/*
/assets/wpx-out-of-stock.js
loaded inisde layout/theme.liquid with <script src="{{ 'wpx-out-of-stock.js' | asset_url }}" defer></script>

added css inside customizer...
.btn--preorder {
  background-color: #ff4f33 !important;
  color: white !important;
}

Changes the label and background color of the "Add to cart" button if the product is out of stock.
*/

document.addEventListener('DOMContentLoaded', () => {
  const updatePreorderStyle = () => {
    const outOfStockElement = document.querySelector('.icon--outofstock');
    const addToCartBtn = document.querySelector('button.add-to-cart');
    if (!addToCartBtn || !outOfStockElement) return;

    const isVisible = outOfStockElement.offsetParent !== null;
    const btnText = addToCartBtn.querySelector('[data-add-to-cart-text]');

    if (isVisible) {
      addToCartBtn.classList.add('btn--preorder');
      if (btnText) btnText.textContent = 'PRE-ORDER NOW';
    } else {
      addToCartBtn.classList.remove('btn--preorder');
      if (btnText) btnText.textContent = btnText.getAttribute('data-default-text') || 'Add to cart';
    }
  };

  // Run on load
  updatePreorderStyle();

  // Run on variant change
  document.querySelectorAll('[data-product-select], .product-single__variants').forEach(select => {
    select.addEventListener('change', () => {
      setTimeout(updatePreorderStyle, 50); // Delay to let DOM update
    });
  });
});